var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "room-upgrade-modal-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "room-upgrade-modal-image",
        style: [
          {
            "background-image":
              "url(" +
              _vm.previousRoomUpgradeImage +
              "?wid=1280&hei=659&fmt=jpeg&op_usm=1,1,5,0&resMode=sharp2&fit=crop&qlt=75,0)",
          },
        ],
      },
      [
        _c("span", { staticClass: "room-upgrade-modal-image-price-tag" }, [
          _vm._v(
            _vm._s(
              _vm.tc("booking.onlyMorePerNight", {
                price: _vm.formatPrice(_vm.roomUpgradePriceDifference),
              })
            )
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "room-upgrade-modal-image-content" }, [
          _c("div", { staticClass: "room-upgrade-modal-image-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.tc("booking.upgradeYourRoom")) +
                "\n      "
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { ref: "modalContent", staticClass: "room-upgrade-modal-content" },
      [
        _c("div", { staticClass: "comparison-card" }, [
          _c(
            "div",
            {
              staticClass: "comparison-card-title comparison-card-title--light",
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.roomUpgradeSelected
                      ? _vm.tc("booking.yourOriginalSelection")
                      : _vm.tc("booking.yourRoom")
                  ) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "comparison-card-room-name" }, [
            _vm._v("\n        " + _vm._s(_vm.currentRoomName) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "comparison-card-room-description",
            domProps: { innerHTML: _vm._s(_vm.currentRoomDescription) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "comparison-card" }, [
          _c(
            "div",
            { staticClass: "comparison-card-title comparison-card-title--red" },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.tc("booking.upgradeYourRoom")) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "comparison-card-room-name" }, [
            _vm._v("\n        " + _vm._s(_vm.upgradeRoomName) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "comparison-card-room-description",
            domProps: { innerHTML: _vm._s(_vm.upgradeRoomDescription) },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }